"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Template;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _app_css = _interopRequireDefault(require("wapplr/dist/common/template/app_css.js"));
var _template_css = _interopRequireDefault(require("wapplr/dist/common/template/template_css.js"));
var _getUtils = _interopRequireDefault(require("../Wapp/getUtils"));
var _Wapp = require("../Wapp");
var _Logo = _interopRequireDefault(require("../Logo"));
function Template(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  var utils = (0, _getUtils["default"])(context);
  var children = props.children,
    _props$footerMenu = props.footerMenu,
    footerMenu = _props$footerMenu === void 0 ? [{
      name: "HOME",
      href: "/"
    }, {
      name: "404",
      href: "/404"
    }, {
      name: "500",
      href: "/500"
    }, {
      name: "EXTERNAL",
      href: "https://google.com",
      target: "_blank"
    }] : _props$footerMenu,
    _props$Logo = props.Logo,
    Logo = _props$Logo === void 0 ? _Logo["default"] : _props$Logo,
    subscribe = props.subscribe;
  var styles = wapp.styles;
  var _wapp$config$siteName = wapp.config.siteName,
    siteName = _wapp$config$siteName === void 0 ? "Wapplr" : _wapp$config$siteName;
  var copyright = "".concat(siteName, " ").concat(new Date().getFullYear(), " \xA9");
  styles.use(_template_css["default"]);
  styles.use(_app_css["default"]);
  var defaultUrl = utils.getRequestUrl();
  var _useState = (0, _react.useState)(defaultUrl),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  function onLocationChange(newUrl) {
    if (url !== newUrl) {
      setUrl(newUrl);
    }
  }
  function onScroll(e) {
    var header = document.querySelector("." + _template_css["default"].header);
    header.classList.toggle(_template_css["default"].sticky, window.scrollY > 0);
  }
  (0, _react.useEffect)(function didMount() {
    window.addEventListener("scroll", onScroll);
    var unsub = subscribe ? subscribe.locationChange(onLocationChange) : null;
    if (defaultUrl !== url) {
      setUrl(defaultUrl);
    }
    return function willUnmount() {
      window.removeEventListener("scroll", onScroll);
      if (unsub) {
        unsub();
      }
    };
  }, [url]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _template_css["default"].page
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: _template_css["default"].header
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _template_css["default"].innerHeader
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _template_css["default"].logo
  }, Logo ? /*#__PURE__*/_react["default"].createElement(Logo, null) : null))), /*#__PURE__*/_react["default"].createElement("main", {
    className: _template_css["default"].content
  }, children), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _template_css["default"].footer
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _template_css["default"].menu
  }, (0, _toConsumableArray2["default"])(footerMenu.map(function (menu, key) {
    var target = menu.target || "self";
    var noReferrer = target === "_blank" ? "noreferrer" : null;
    var href = menu.href;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _template_css["default"].button,
      target: target,
      href: href,
      rel: noReferrer,
      onClick: function onClick(e) {
        var inner = !(target === "_blank" || href && href.slice(0, 7) === "http://" || href && href.slice(0, 8) === "https://");
        if (inner) {
          wapp.client.history.push((0, _objectSpread2["default"])({
            search: "",
            href: ""
          }, wapp.client.history.parsePath(href)));
          e.preventDefault();
        }
      }
    }, menu.name));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _template_css["default"].copyright
  }, copyright))));
}